angular.module('app.facilitadores', [
  'ui.router',
  'toastr',
  'app.facilitadoresdService',
  'zingchart-angularjs'
])

.config(
  [          '$stateProvider', '$urlRouterProvider',
    function ($stateProvider,   $urlRouterProvider) {
      $stateProvider
        .state('index.facilitadores', {

          abstract: true,

          url: 'facilitadores',

          params: {

          },

          views: {
            '': {
              templateUrl: 'app/facilitadores/facilitadores.tpl.html',
              resolve: {

              },
              controller: ['$scope', '$state', 'toastr',
                function (  $scope,   $state,   toastr) {



                }]
            }
          }

        })
        .state( 'index.facilitadores.list', {
          url: '',
          views: {
            '': {
              templateUrl: 'app/facilitadores/facilitadores.list.tpl.html',
              controller: ['$scope', '$state', 'toastr','facilitadoresdService', 'parametrizacionService', '$document',
                function (  $scope,   $state,   toastr , facilitadoresdService, parametrizacionService, $document) {
                  
                  //cambio de pestaña activa
                  $scope.enfoqueServicios(3);

                  meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
                  dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

                  reinicioDataLabelChart = function()
                  {
                    if ($scope.dataGraficaCoberturaRegiones != undefined)
                    {
                      if ($scope.menuregiones)
                      {
                        ciclo = $scope.dataGraficaCoberturaRegiones.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataGraficaCoberturaRegiones[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataGraficaCoberturaRegiones = [""];
                        $scope.labelsGraficaCoberturaRegiones = [""]
                      }
                    }
  
                    if ($scope.dataGraficaCobertura != undefined)
                    {
                      if ($scope.menudepartamentos)
                      {
                        ciclo = $scope.dataGraficaCobertura.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataGraficaCobertura[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataGraficaCobertura = [""];
                        $scope.labelsGraficaCobertura = [""];
                      }
                    }
                    
                    if ($scope.dataGraficaFacilitadoresRegiones != undefined)
                    {
                      if ($scope.menuregiones)
                      {
                        ciclo = $scope.dataGraficaFacilitadoresRegiones.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataGraficaFacilitadoresRegiones[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataGraficaFacilitadoresRegiones = [""];
                        $scope.labelsGraficaFacilitadoresRegiones = [""]
                      }
                    }
  
                    if ($scope.dataGraficaFacilitadores != undefined)
                    {
                      if ($scope.menudepartamentos)
                      {
                        ciclo = $scope.dataGraficaFacilitadores.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataGraficaFacilitadores[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataGraficaFacilitadores = [""];
                        $scope.labelsGraficaFacilitadores = [""];
                      }
                    }
                    
                    if ($scope.dataGraficaFacilitadoresSexos != undefined)
                    {
                      if ($scope.menusexos)
                      {
                        ciclo = $scope.dataGraficaFacilitadoresSexos.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataGraficaFacilitadoresSexos[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataGraficaFacilitadoresSexos = [""];
                        $scope.labelsChartSexo = [""];
                      }
                    }
                  }

                  //esta sección se activa desde municipios
                  $scope.selectedRegionExterno = function()
                  {
                    $scope.selectedRegion($scope.dataRegiones[0],false);
                  }

                  $scope.selectedDepartamentoExterno = function()
                  {
                    cargaDepartamentos($scope.rangoEstadisticas.ID_REGION,false);
                  }

                  $scope.selectedDepartamento = function (item,externo,comboexterno)
                  {
                    if (comboexterno)
                    {
                      $scope.grafica_departamentos_activa = false;
                    }

                    reinicioDataLabelChart();

                    $scope.rangoEstadisticas.ID_DEPARTAMENTO = item.ID_DEPARTAMENTO;
                    $scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO = item.ID_DEPARTAMENTO_ISO;
                    $scope.rangoEstadisticas.DEPARTAMENTO = item.DEPARTAMENTO;
                    $scope.rangoEstadisticas.ID_DESPACHO = "0";
                    $scope.currentItem = undefined;

                    if (($scope.tipoGraficos != undefined))
                    {
                      if ($scope.rangoEstadisticas.ID_REGION == 0)
                      {
                        $scope.tipoGraficos[1].MOSTRAR = true;
                      }
                      $scope.tipoGraficos[2].MOSTRAR = true;
                    }
                    
                    if ((($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes)) && 
                        ((!$scope.grafica_departamentos_activa) && (!$scope.grafica_regiones_activa)))
                    {
                      console.log("if ((($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes)) && ");
                      if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO == 0))
                      {
                        if ($scope.menudepartamentos)
                        {
                          asignarTipoGrafico();
                          $scope.tipoGraficos[1].MOSTRAR = false;
                          $scope.tipoGraficos[4].MOSTRAR = false;
                          $scope.tipoGraficos[1].ENFOQUE = false;
                          $scope.tipoGraficos[2].ENFOQUE = true;
                          $scope.tipoGraficos[3].ENFOQUE = false;
                          $scope.tipoGraficos[4].ENFOQUE = false;
                          if ($scope.menuparticipantes)
                          {
                            $scope.tipoGraficos[4].MOSTRAR = true;
                          }
                        }
                        else if ($scope.menumunicipios)
                        {
                          $scope.tipoGraficos[1].MOSTRAR = false;
                        }
                      }
                      else if  (item.ID_DEPARTAMENTO > 0)
                      {
                        asignarTipoGrafico();
                        $scope.tipoGraficos[1].MOSTRAR = false;
                        $scope.tipoGraficos[2].MOSTRAR = false;
                        $scope.tipoGraficos[1].ENFOQUE = false;
                        $scope.tipoGraficos[2].ENFOQUE = false;
                        if ($scope.menusexos)
                        {
                          $scope.tipoGraficos[4].MOSTRAR = true;
                          $scope.tipoGraficos[4].ENFOQUE = true;
                        }
                        else
                        {
                          $scope.tipoGraficos[3].ENFOQUE = true;
                          $scope.enfocarPestanaInterna(4,false);
                        }
                      }
                    }
                    else if (externo && $scope.grafica_departamentos_activa)
                    {
                      console.log("else if (externo && $scope.grafica_departamentos_activa)");
                      //if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      //{
                        asignarTipoGrafico();
                        $scope.tipoGraficos[1].MOSTRAR = false;
                        $scope.tipoGraficos[2].MOSTRAR = false;
                        $scope.tipoGraficos[1].ENFOQUE = false;
                        $scope.tipoGraficos[2].ENFOQUE = false;
                        $scope.tipoGraficos[3].ENFOQUE = true;
                      //}
                      $scope.enfocarPestanaInterna(4,false);
                    }
                    else if ($scope.grafica_departamentos_activa)
                    {
                      console.log("else if ($scope.grafica_departamentos_activa)");
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {
                        asignarTipoGrafico();
                        $scope.tipoGraficos[1].MOSTRAR = false;
                        $scope.tipoGraficos[2].MOSTRAR = true;
                        $scope.tipoGraficos[4].MOSTRAR = false;
                        $scope.tipoGraficos[1].ENFOQUE = false;
                        $scope.tipoGraficos[2].ENFOQUE = true;
                        $scope.tipoGraficos[3].ENFOQUE = false;
                        $scope.tipoGraficos[4].ENFOQUE = false;
                        if ($scope.menuparticipantes)
                        {
                          $scope.tipoGraficos[4].MOSTRAR = true;
                        }
                      }
                      if ($scope.rangoEstadisticas.ID_REGION == 0)
                      {
                        $scope.tipoGraficos[1].MOSTRAR = true;
                      }
                      $scope.enfocarPestanaInterna(3,false);  
                    }
                    else if (item.ID_DEPARTAMENTO > 0)
                    {
                      console.log("else if (item.ID_DEPARTAMENTO > 0)");
                      if (($scope.menuregiones) || ($scope.menudepartamentos))
                      {
                        if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                        {
                          $scope.tipoGraficos[1].MOSTRAR = false;
                          $scope.tipoGraficos[2].MOSTRAR = false
                          $scope.tipoGraficos[4].MOSTRAR = false;
                          $scope.tipoGraficos[1].ENFOQUE = false;
                          $scope.tipoGraficos[2].ENFOQUE = false;
                          $scope.tipoGraficos[3].ENFOQUE = true;
                          $scope.tipoGraficos[4].ENFOQUE = false;
                          if ($scope.menuparticipantes)
                          {
                            $scope.tipoGraficos[4].MOSTRAR = true;
                          }
                          $scope.enfocarPestanaInterna(4,true);
                        }
                        else
                        {
                          $scope.enfocarPestanaInterna(1,true);
                        }
                      }
                      $scope.tipoGraficos[1].MOSTRAR = false;
                      $scope.tipoGraficos[2].MOSTRAR = false;
                    }
                    else if ($scope.rangoEstadisticas.ID_REGION > 0)
                    {
                      console.log("else if ($scope.rangoEstadisticas.ID_REGION > 0)");
                      $scope.tipoGraficos[1].MOSTRAR = false;
                      $scope.tipoGraficos[1].ENFOQUE = false;
                      $scope.tipoGraficos[2].ENFOQUE = true;
                      
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {  
                        if ($scope.menuregiones)
                        {
                          $scope.enfocarPestanaInterna(3,true);
                        }
                      }
                    }
                    
                    if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO > 0))
                    {
                      $scope.tipoGraficos[1].MOSTRAR = false;
                      $scope.tipoGraficos[2].MOSTRAR = false;
                    }

                    if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO == 0))
                    {
                      $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación"; 
                      $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                    }
                    else if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO > 0))
                    {
                      $scope.tooltip_mapa = "Para volver a todos los departamentos de la región, haga clic en un departamento no filtrado";
                      $scope.tooltip_mapaB="";
                    }
                    else if (item.ID_DEPARTAMENTO > 0 )
                    {
                      $scope.tooltip_mapa="";
                      $scope.tooltip_mapaB = "";
                    }

                    $scope.cargaEstadisticas(true,$scope.pestanaActiva);
                  }

                  //se cargan los departamentos
                  cargaDepartamentos = function(region)
                  {
                    parametrizacionService.getDeptoMunicipioCentros(region,1,5).then( function ( response ) {
                      $scope.dataDepartamentos=response.data;
                      $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }

                  $scope.selectedRegion = function (item,externo,comboexterno)
                  {
                    if (comboexterno)
                    {
                      $scope.grafica_regiones_activa = false;
                    }

                    $scope.rangoEstadisticas.ID_REGION = item.ID_REGION;
                    $scope.rangoEstadisticas.REGION = item.REGION;
                    $scope.rangoEstadisticas.COLOR = item.COLOR;
                    $scope.currentItem = undefined;

                    if ($scope.tipoGraficos != undefined)
                    {
                      if ($scope.rangoEstadisticas.ID_REGION == 0)
                      {
                        $scope.tipoGraficos[1].MOSTRAR = true;
                      }
                    }

                    console.log("condicion",$scope.menuactividadesfacilitadores,$scope.menuactividadesjueces,$scope.menuparticipantes,!$scope.grafica_regiones_activa);

                    if ((($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes)) && (!$scope.grafica_regiones_activa))
                    {
                      console.log("es externo ");
                      if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.menuregiones))
                      {
                        asignarTipoGrafico();
                        $scope.tipoGraficos[1].MOSTRAR = false;
                        if ($scope.menuregiones)
                        {
                          $scope.tipoGraficos[4].MOSTRAR = false;
                          $scope.tipoGraficos[1].ENFOQUE = false;
                          $scope.tipoGraficos[2].ENFOQUE = true;
                          $scope.tipoGraficos[3].ENFOQUE = false;
                          $scope.tipoGraficos[4].ENFOQUE = false;
                          if ($scope.menuparticipantes)
                          {
                            $scope.tipoGraficos[4].MOSTRAR = true;
                          }
                        }
                        $scope.enfocarPestanaInterna(3,false);
                      }
                    }
                    else if (externo && $scope.grafica_regiones_activa && !$scope.grafica_departamentos_activa)
                    {
                      console.log("(externo && $scope.grafica_regiones_activa && !$scope.grafica_departamentos_activa)");
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {
                        asignarTipoGrafico();
                        if ($scope.rangoEstadisticas.ID_REGION > 0)
                        {
                          $scope.tipoGraficos[1].MOSTRAR = false;
                          $scope.tipoGraficos[4].MOSTRAR = false;
                          $scope.tipoGraficos[1].ENFOQUE = false;
                          $scope.tipoGraficos[2].ENFOQUE = true;
                          $scope.tipoGraficos[3].ENFOQUE = false;
                          $scope.tipoGraficos[4].ENFOQUE = false;
                          if ($scope.menuparticipantes)
                          {
                            $scope.tipoGraficos[4].MOSTRAR = true;
                          }
                        }
                      }
                      $scope.enfocarPestanaInterna(3,false);
                    }
                    else if (!externo && $scope.grafica_regiones_activa && $scope.grafica_departamentos_activa)
                    {
                      $scope.grafica_departamentos_activa = false;
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {
                        $scope.tipoGraficos[1].MOSTRAR = false;
                        $scope.tipoGraficos[2].MOSTRAR = false;
                        $scope.tipoGraficos[4].MOSTRAR = false;
                        $scope.tipoGraficos[1].ENFOQUE = true;
                        $scope.tipoGraficos[2].ENFOQUE = false;
                        $scope.tipoGraficos[3].ENFOQUE = false;
                        $scope.tipoGraficos[4].ENFOQUE = false;
                        if ($scope.menuparticipantes)
                        {
                          $scope.tipoGraficos[4].MOSTRAR = true;
                        }
                      }
                      $scope.enfocarPestanaInterna(2,false);
                    }
                    else if ($scope.grafica_regiones_activa && !$scope.grafica_departamentos_activa)
                    {
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {
                        if ($scope.rangoEstadisticas.ID_REGION == 0)
                        {
                          $scope.tipoGraficos[4].MOSTRAR = false;
                          $scope.tipoGraficos[1].ENFOQUE = true;
                          $scope.tipoGraficos[2].ENFOQUE = false;
                          $scope.tipoGraficos[3].ENFOQUE = false;
                          $scope.tipoGraficos[4].ENFOQUE = false;
                          if ($scope.menuparticipantes)
                          {
                            $scope.tipoGraficos[4].MOSTRAR = true;
                          }
                        }
                      }
                      $scope.enfocarPestanaInterna(2,false);
                    }
                    else if (item.ID_REGION > 0)
                    {
                      if ($scope.menuregiones)
                      { 
                        asignarTipoGrafico();
                        $scope.enfocarPestanaInterna(1,true);
                      }
                      $scope.tipoGraficos[1].MOSTRAR = false;
                    }

                    if (item.ID_REGION == 0)
                    {
                      $scope.tooltip_mapa = "Para filtrar una región, haga clic en un departamento";
                      $scope.tooltip_mapaB = "";
                    }
                    else if (item.ID_REGION > 0)
                    {
                      $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación";
                      $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                    }
                    
                    cargaDepartamentos(item.ID_REGION);
                  }

                  cargaRegiones = function()
                  {
                    $scope.dataRegiones = [];
                    parametrizacionService.getDeptoMunicipioCentros(0,0,4).then( function ( response ) {
                      $scope.dataRegiones=response.data;
                      $scope.selectedRegion($scope.dataRegiones[0],false);
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
  
                  cargaRegiones();
  
                  cambiaGrafica = function(parametro,arreglo,opcion)
                  {
                    switch (opcion) {
                      case "region":
                        for (var i=0; i < arreglo.length; i++) 
                        {
                          if (arreglo[i].REGION === parametro) 
                          {
                            $scope.selectedRegion(arreglo[i],true);
                          }
                        }
                      break;
                      case "departamento":
                        for (var i=0; i < arreglo.length; i++) 
                        {
                          if (arreglo[i].DEPARTAMENTO === parametro) 
                          {
                            $scope.selectedDepartamento(arreglo[i],true);
                          }
                        }
                      break;
                    }
                  }

                  $scope.grafica_regiones_activa = false;
                  $scope.grafica_departamentos_activa = false;

                  $scope.onClickChartRegiones = function (points, evt, sergment) 
                  {  
                    if (points.length > 0)
                    { 
                      $scope.grafica_regiones_activa = true;
                      $scope.grafica_departamentos_activa = false;
                      cambiaGrafica(points[0]._model.label,$scope.dataRegiones,'region');
                    }
                  }

                  $scope.onClickChartDepartamentos = function (points, evt, sergment) 
                  {
                    if (points.length > 0)
                    { 
                      $scope.grafica_departamentos_activa = true;
                      cambiaGrafica(points[0]._model.label,$scope.dataDepartamentos,'departamento');
                    }
                  }

                  duration = 1500;
                  offset = 20;

                  $scope.scrollToElement = function(element)
                  {
                    elemento = angular.element(document.getElementById(element));
                    $document.scrollToElement(elemento, offset, duration);
                  }

                  fechaTituloDia = function(date)
                  {
                    d = new Date(date);
                    day = d.getDate();
                    dia = dias[d.getDay()];
                    mes = meses[d.getMonth()];
                    anio= d.getFullYear();
                    tituloCalendario = ' el '+dia+' '+day +' de '+ mes +' de '+  anio;
                    return tituloCalendario;
                  }

                  fechaTituloRangoDiasSemana = function(numerodiainicio,diainicio, mesinicio, anioinicio, numerodiafin, diafin, mesfin, aniofin)
                  {
                    //d = new Date(date);
                    //day = d.getDay();
                    //diff = d.getDate() - day + (day == 0 ? -6 : 1);
                    //inicio = new Date(d.setDate(diff));            
                    //d = new Date(date);
                    //day = d.getDay();
                    //diff = d.getDate() - day + (day == 0 ? -6 : 5);
                    //viernes = new Date(d.setDate(diff));
                    diaInicial = diainicio; //inicio.getDate();
                    diaInicialNombre = dias[numerodiainicio];
                    mesInicial = meses[mesinicio-1];//meses[inicio.getMonth()];
                    anioInicial= anioinicio;//inicio.getFullYear();
                    diaFinal = diafin;//viernes.getDate();
                    diaFinalNombre = dias[numerodiafin];
                    mesFinal = meses[mesfin-1];//meses[viernes.getMonth()];
                    anioFinal= aniofin;//viernes.getFullYear();
                    tituloCalendario = ' del '+diaInicialNombre+' '+diaInicial;
                    
                    if (mesInicial != mesFinal)
                    {
                      tituloCalendario = tituloCalendario +' de '+ mesInicial;
                    }
                    else if ((mesInicial == mesFinal) && (anioInicial != anioFinal))
                    {
                      tituloCalendario = tituloCalendario +' de '+ mesInicial;
                    }

                    if (anioInicial != anioFinal)
                    {
                      tituloCalendario = tituloCalendario +' de '+ anioInicial;
                    }
                    
                    tituloCalendario = tituloCalendario +' al '+diaFinalNombre+' '+diaFinal+' de '+mesFinal+' de '+anioFinal;
                    return tituloCalendario;
                  }

                  fechaTituloRangoDiasMes = function(date)
                  {
                    d = new Date(date);
                    mes = meses[d.getMonth()];
                    anio= d.getFullYear();
                    tituloCalendario = ' en '+mes +' de '+  anio;
                    return tituloCalendario;
                  }

                  fechaTituloRangoDiasAnio = function(date)
                  {
                    d = new Date(date);
                    anio= d.getFullYear();
                    tituloCalendario = anio;
                    return ' en '+tituloCalendario;
                  }

                  //titulo rango de fechas
                  fechaTituloFechas = function(fechainicio, fechafin)
                  {
                    fechainicial = new Date(fechainicio)
                    diainicio = fechainicial.getDate();
                    mesinicio = fechainicial.getMonth()+1;
                    anioinicio = fechainicial.getFullYear();

                    fechafinal = new Date(fechafin)
                    diafin = fechafinal.getDate();
                    mesfin = fechafinal.getMonth()+1;
                    aniofin = fechafinal.getFullYear();
                    
                    ultimodiamesfechafin = new Date(fechafinal.getFullYear(), fechafinal.getMonth()+1, 0);
                    ultimodiamesfin = ultimodiamesfechafin.getDate();                  

                    if ((anioinicio == aniofin) && (mesinicio == mesfin) && (diainicio == diafin))
                    {
                      $scope.fecha_tipo_casos_texto = fechaTituloDia(fechainicio);
                    }
                    else if((anioinicio == aniofin) && (mesinicio == mesfin) && (diainicio == 1) && (diafin == ultimodiamesfin))
                    {
                      $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasMes(fechainicio);
                    }
                    else if((anioinicio == aniofin) && (mesinicio == 1) && (mesfin == 12) && (diainicio == 1) && (diafin == ultimodiamesfin))
                    {
                      $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasAnio(fechainicio);
                    }
                    else
                    {
                      $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasSemana(fechainicial.getDay(),diainicio,mesinicio,anioinicio,fechafinal.getDay(),diafin,mesfin,aniofin);
                    }
                  }

                  $scope.cargaEstadisticas = function(isValid,opcion,externo)
                  {
                    var fecha = moment($scope.rangoEstadisticas.FECHA).format("DD-MM-YYYY");
                    var fechaFin = moment($scope.rangoEstadisticas.FECHA_FIN).format("DD-MM-YYYY");
                    fechaTituloFechas($scope.rangoEstadisticas.FECHA,$scope.rangoEstadisticas.FECHA_FIN);
                    $scope.mostrarfechafin = true;
                    
                    if ( isValid) 
                    {
                      switch (opcion) {
                        case 1:
                          cargaEstadisticasCoberturaServicio(fecha,fechaFin,externo);
                            break;
                        case 2:
                          cargaEstadisticasFacilitadores(fecha,fechaFin,externo);
                            break;
                        case 3:
                            $scope.mostrarfechafin = false;
                            cargaEstadisticasActividadesFacilitadoresDepartamento(fecha,fechaFin,externo);
                          break;
                        case 4:
                            $scope.mostrarfechafin = false;
                            cargaEstadisticasActividadesJuecesDepartamento(fecha,fechaFin,externo);
                          break;
                        case 5:
                            $scope.mostrarfechafin = false;
                            cargaEstadisticasParticipantesCharlasDepartamento(fecha,fechaFin,externo);
                          break;
                        } 
                    }
                  }
  
                  //Cobertura
                  cargaEstadisticasCoberturaServicio = function(fecha,fechaFin,externo)
                  {
                    facilitadoresdService.getCoberturaFJ22("menu"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,fecha
                                                          ,fechaFin
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.coberturaMenu=response.data.data;
                      $scope.rangoEstadisticas.TITULO = $scope.coberturaMenu[$scope.ordenMenu].TITULO;
                      $scope.rangoEstadisticas.TITULO_MAPA = $scope.coberturaMenu[$scope.ordenMenu].TITULO_MAPA;
                      $scope.rangoEstadisticas.TITULO_GRAFICA = $scope.coberturaMenu[$scope.ordenMenu].TITULO_GRAFICA;
                      $scope.rangoEstadisticas.TITULO_TABLA = $scope.coberturaMenu[$scope.ordenMenu].TITULO_TABLA;
                      $scope.rangoEstadisticas.ID = $scope.coberturaMenu[$scope.ordenMenu].ID;
                      $scope.rangoEstadisticas.MOSTRAR_FECHAS = $scope.coberturaMenu[$scope.ordenMenu].MOSTRAR_FECHAS;
                      $scope.coberturaMenu[$scope.ordenMenu].MOSTRARMENU = true;

                      $scope.rangoEstadisticas.FECHA_DESHABILITADA = "";
                      if (($scope.rangoEstadisticas.ID == "IMPLEMENTADO") || ($scope.rangoEstadisticas.ID == "NOIMPLEMENTADO"))
                      {
                        $scope.rangoEstadisticas.FECHA_DESHABILITADA = "Opción no disponible para el menú '"+$scope.coberturaMenu[$scope.ordenMenu].TEXTO+"'";
                      }

                      cargaEstadisticasCoberturaServicioGraficas(fecha,fechaFin);
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
                  
                  cargaEstadisticasFacilitadores = function(fecha,fechaFin,externo)
                  {
                    facilitadoresdService.getFacilitadoresFJ22("menu"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,fecha
                                                          ,fechaFin
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.facilitadoresMenu=response.data.data;
                      $scope.rangoEstadisticas.TITULO = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO;
                      $scope.rangoEstadisticas.TITULO_MAPA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_MAPA;
                      $scope.rangoEstadisticas.TITULO_GRAFICA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_GRAFICA;
                      $scope.rangoEstadisticas.TITULO_TABLA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_TABLA;
                      $scope.rangoEstadisticas.TITULO_SEXOS = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_SEXOS;
                      $scope.rangoEstadisticas.ID = $scope.facilitadoresMenu[$scope.ordenMenu].ID;
                      $scope.rangoEstadisticas.MOSTRAR_FECHAS = $scope.facilitadoresMenu[$scope.ordenMenu].MOSTRAR_FECHAS;
                      $scope.facilitadoresMenu[$scope.ordenMenu].MOSTRARMENU = true;

                      $scope.rangoEstadisticas.FECHA_DESHABILITADA = "";
                      if ($scope.rangoEstadisticas.ID == "FACILITADORESREGISTRADOS")
                      {
                        $scope.rangoEstadisticas.FECHA_DESHABILITADA = "Opción no disponible para el menú '"+$scope.facilitadoresMenu[$scope.ordenMenu].TEXTO+"'";
                      }

                      cargaEstadisticasFacilitadoresGraficas(fecha,fechaFin);
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
   
                  cargaEstadisticasCoberturaServicioGraficas = function(fecha,fechaFin)
                  {
                    facilitadoresdService.getCoberturaFJ22($scope.rangoEstadisticas.ID+"mapa"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,fecha
                                                          ,fechaFin
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.zingMapCobertura.shapes[0].options.style.items=response.data.mapa;
                    
                    $scope.labelsGraficaCobertura=response.data.labels;
                    $scope.dataGraficaCobertura=response.data.data;
                    $scope.backgroundColorGraficaCobertura=response.data.colors;
                    $scope.labelsIsoGraficaCobertura=response.data.isolabels;
                    
                    if ($scope.labelsIsoGraficaCobertura.length == 2)
                    {
                      $scope.rangoEstadisticas.COLOR = $scope.labelsIsoGraficaCobertura[0].color;
                    }

                    facilitadoresdService.getCoberturaFJ22($scope.rangoEstadisticas.ID+"municipios"
                      ,$scope.rangoEstadisticas.ID_REGION
                      ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                      ,fecha
                      ,fechaFin
                      ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.coberturaMunicipios=response.data.data;

                      if ($scope.rangoEstadisticas.ID_BASE_COLOR == 3)
                      {
                        //municipios
                        for (i=0;i < $scope.labelsIsoGraficaCobertura.length;i++)
                        {
                          for (j=0;j < $scope.coberturaMunicipios.length;j++)
                          {
                            if ($scope.labelsIsoGraficaCobertura[i].id_iso_depto == $scope.coberturaMunicipios[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.coberturaMunicipios[j].COLOR = $scope.labelsIsoGraficaCobertura[i].color;
                            }
                          }
                        }
                      }

                      }, function ( error ) {
                      toastr.error( error );
                      });
                    
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                    {
                      facilitadoresdService.getCoberturaFJ22($scope.rangoEstadisticas.ID+"regiones"
                                                            ,$scope.rangoEstadisticas.ID_REGION
                                                            ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                            ,fecha
                                                            ,fechaFin
                                                            ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.labelsGraficaCoberturaRegiones=response.data.labels;
                      $scope.dataGraficaCoberturaRegiones=response.data.data;
                      $scope.backgroundColorGraficaCoberturaRegiones= response.data.colors;
                        
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }

                  }

                  cargaEstadisticasFacilitadoresGraficas = function(fecha,fechaFin)
                  {
                    facilitadoresdService.getFacilitadoresFJ22($scope.rangoEstadisticas.ID+"mapa"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,fecha
                                                          ,fechaFin
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.zingMapFacilitadores.shapes[0].options.style.items=response.data.mapa;
                    
                    $scope.labelsGraficaFacilitadores=response.data.labels;
                    $scope.dataGraficaFacilitadores=response.data.data;
                    $scope.backgroundColorGraficaFacilitadores= response.data.colors;
                    $scope.labelsIsoGraficaFacilitadores=response.data.isolabels;
                    
                    if ($scope.labelsIsoGraficaFacilitadores.length == 2)
                    {
                      $scope.rangoEstadisticas.COLOR = $scope.labelsIsoGraficaFacilitadores[0].color;
                    }

                    facilitadoresdService.getFacilitadoresFJ22($scope.rangoEstadisticas.ID+"municipios"
                      ,$scope.rangoEstadisticas.ID_REGION
                      ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                      ,fecha
                      ,fechaFin
                      ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.facilitadoresMunicipios=response.data.data;

                      if ($scope.rangoEstadisticas.ID_BASE_COLOR == 3)
                      {
                        //municipios
                        for (i=0;i < $scope.labelsIsoGraficaFacilitadores.length;i++)
                        {
                          for (j=0;j < $scope.facilitadoresMunicipios.length;j++)
                          {
                            if ($scope.labelsIsoGraficaFacilitadores[i].id_iso_depto == $scope.facilitadoresMunicipios[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.facilitadoresMunicipios[j].COLOR = $scope.labelsIsoGraficaFacilitadores[i].color;
                            }
                          }
                        }
                      }

                      }, function ( error ) {
                      toastr.error( error );
                      });
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                    {
                      facilitadoresdService.getFacilitadoresFJ22($scope.rangoEstadisticas.ID+"regiones"
                                                            ,$scope.rangoEstadisticas.ID_REGION
                                                            ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                            ,fecha
                                                            ,fechaFin
                                                            ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.labelsGraficaFacilitadoresRegiones=response.data.labels;
                      $scope.dataGraficaFacilitadoresRegiones=response.data.data;
                      $scope.backgroundColorGraficaFacilitadoresRegiones= response.data.colors;
                        
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }

                    facilitadoresdService.getFacilitadoresFJ22($scope.rangoEstadisticas.ID+"sexos"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,fecha
                                                          ,fechaFin
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.labelsGraficaFacilitadoresSexos=response.data.labels;
                    $scope.dataGraficaFacilitadoresSexos=response.data.data;
                    $scope.backgroundColorGraficaFacilitadoresSexos= response.data.colors;

                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }

                  $scope.registrosChartDepartamentos = "";
                  $scope.paginacionGraficaDepartamentosFacilitadores = function(item)
                  {
                    $scope.currentItem = $scope.topChartFacilitadores[item-1];
                    $scope.registrosChartDepartamentos = $scope.topInicialChartFacilitadores[item-1]
                    +"-"+$scope.topFinalChartFacilitadores[item-1]+" de "
                    +$scope.topFinalChartFacilitadores[($scope.topFinalChartFacilitadores.length)-1]
                    +" registros";
                    
                    $scope.labelsGraficaFacilitadores = [];
                    $scope.dataGraficaFacilitadores = [];
                    $scope.backgroundColorGraficaFacilitadores = [];

                    for (i=($scope.topInicialChartFacilitadores[item-1])-1;i < $scope.topFinalChartFacilitadores[item-1];i++)
                    {
                      $scope.labelsGraficaFacilitadores.push($scope.labelsGraficaFacilitadoresTemp[i]);
                      $scope.dataGraficaFacilitadores.push($scope.dataGraficaFacilitadoresTemp[i]);
                      $scope.backgroundColorGraficaFacilitadores.push($scope.backgroundColorGraficaFacilitadoresTemp[i]);
                    }
                  }

                  cargaEstadisticasActividadesFacilitadoresDepartamento = function(fecha,fechaFin)
                  {
                    facilitadoresdService.getActividadesFacilitadores24('MENU'
                                                                        ,'MENUACTIVIDADESFJ'
                                                                        ,$scope.rangoEstadisticas.ID_REGION
                                                                        ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                        ,fecha
                                                                        ,fechaFin
                                                                        ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                      ).then( function ( response ) {
                      $scope.actividadesFacilitadoresJuecesParticipantes=response.data.data;
                      $scope.rangoEstadisticas.TITULO = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO;
                      $scope.rangoEstadisticas.TITULO_COLUMNA = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO_COLUMNA;
                      $scope.rangoEstadisticas.ID_ACTIVIDAD = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ID_ACTIVIDAD;
                      $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ACTIVO = "true";
                      
                      $scope.rangoEstadisticas.MOSTRAR_FECHAS = true;

                      facilitadoresdService.getActividadesFacilitadores24('MAPAFJ'
                                              ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                              ,$scope.rangoEstadisticas.ID_REGION
                                              ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                              ,fecha
                                              ,fechaFin
                                              ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                            ).then( function ( response ) {

                        $scope.zingMapFacilitadores.shapes[0].options.style.items=response.data.mapa;
                        
                        $scope.labelsGraficaFacilitadores=response.data.labels;
                        $scope.dataGraficaFacilitadores=response.data.data;
                        $scope.backgroundColorGraficaFacilitadores= response.data.colors;
                        $scope.labelsIsoGraficaFacilitadores=response.data.isolabels;
                      
                        if ($scope.labelsIsoGraficaFacilitadores.length == 2)
                        {
                          $scope.rangoEstadisticas.COLOR = $scope.labelsIsoGraficaFacilitadores[0].color;
                        }

                        facilitadoresdService.getActividadesFacilitadores24('MUNICIPIOSFJ'
                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                          ,$scope.rangoEstadisticas.ID_REGION
                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                          ,fecha
                          ,fechaFin
                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                        ).then( function ( response ) {

                        $scope.facilitadoresMunicipios=response.data.data;
                        if ($scope.rangoEstadisticas.ID_BASE_COLOR == 3)
                        {
                          //municipios
                          for (i=0;i < $scope.labelsIsoGraficaFacilitadores.length;i++)
                          {
                            for (j=0;j < $scope.facilitadoresMunicipios.length;j++)
                            {
                              if ($scope.labelsIsoGraficaFacilitadores[i].id_iso_depto == $scope.facilitadoresMunicipios[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.facilitadoresMunicipios[j].COLOR = $scope.labelsIsoGraficaFacilitadores[i].color;
                              }
                            }
                          }
                        }

                        }, function ( error ) {
                        toastr.error( error );
                        });

                      }, function ( error ) {
                      toastr.error( error );
                      });

                      if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO))
                      {
                        facilitadoresdService.getActividadesFacilitadores24('REGIONESFJ'
                                                                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                          ,fecha
                                                                          ,fechaFin
                                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                        ).then( function ( response ) {

                        $scope.labelsGraficaFacilitadoresRegiones=response.data.labels;
                        $scope.dataGraficaFacilitadoresRegiones=response.data.data;
                        $scope.backgroundColorGraficaFacilitadoresRegiones= response.data.colors;

                        }, function ( error ) {
                        toastr.error( error );
                        });
                      }
                      else
                      {
                        $scope.labelsGraficaFacilitadoresRegiones=[];
                        $scope.dataGraficaFacilitadoresRegiones=[];
                        $scope.backgroundColorGraficaFacilitadoresRegiones=[];
                      }

                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }

                  cargaEstadisticasActividadesJuecesDepartamento = function(fecha,fechaFin)
                  {
                    facilitadoresdService.getActividadesFacilitadores24('MENU'
                                                                        ,'MENUACTIVIDADESJUECES'
                                                                        ,$scope.rangoEstadisticas.ID_REGION
                                                                        ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                        ,fecha
                                                                        ,fechaFin
                                                                        ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                      ).then( function ( response ) {
                      $scope.actividadesFacilitadoresJuecesParticipantes=response.data.data;

                      $scope.rangoEstadisticas.TITULO = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO;
                      $scope.rangoEstadisticas.TITULO_COLUMNA = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO_COLUMNA;
                      $scope.rangoEstadisticas.ID_ACTIVIDAD = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ID_ACTIVIDAD;
                      $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ACTIVO = "true";
                      $scope.rangoEstadisticas.MOSTRAR_FECHAS = true;

                      facilitadoresdService.getActividadesFacilitadores24('MAPAJUECES'
                                              ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                              ,$scope.rangoEstadisticas.ID_REGION
                                              ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                              ,fecha
                                              ,fechaFin
                                              ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                            ).then( function ( response ) {

                        $scope.zingMapFacilitadores.shapes[0].options.style.items=response.data.mapa;
                        
                        $scope.labelsGraficaFacilitadores=response.data.labels;
                        $scope.dataGraficaFacilitadores=response.data.data;
                        $scope.backgroundColorGraficaFacilitadores= response.data.colors;
                        $scope.labelsIsoGraficaFacilitadores=response.data.isolabels;
                        
                        if ($scope.labelsIsoGraficaFacilitadores.length == 2)
                        {
                          $scope.rangoEstadisticas.COLOR = $scope.labelsIsoGraficaFacilitadores[0].color;
                        }

                        facilitadoresdService.getActividadesFacilitadores24('MUNICIPIOSJUECES'
                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                          ,$scope.rangoEstadisticas.ID_REGION
                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                          ,fecha
                          ,fechaFin
                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                          ).then( function ( response ) {

                          $scope.facilitadoresMunicipios=response.data.data;
                          if ($scope.rangoEstadisticas.ID_BASE_COLOR == 3)
                          {
                            //municipios
                            for (i=0;i < $scope.labelsIsoGraficaFacilitadores.length;i++)
                            {
                              for (j=0;j < $scope.facilitadoresMunicipios.length;j++)
                              {
                                if ($scope.labelsIsoGraficaFacilitadores[i].id_iso_depto == $scope.facilitadoresMunicipios[j].ID_DEPARTAMENTO_ISO)
                                {
                                  $scope.facilitadoresMunicipios[j].COLOR = $scope.labelsIsoGraficaFacilitadores[i].color;
                                }
                              }
                            }
                          }

                        }, function ( error ) {
                        toastr.error( error );
                        });

                      }, function ( error ) {
                      toastr.error( error );
                      });

                      if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO))
                      {
                        facilitadoresdService.getActividadesFacilitadores24('REGIONESJUECES'
                                                                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                          ,fecha
                                                                          ,fechaFin
                                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                        ).then( function ( response ) {

                        $scope.labelsGraficaFacilitadoresRegiones=response.data.labels;
                        $scope.dataGraficaFacilitadoresRegiones=response.data.data;
                        $scope.backgroundColorGraficaFacilitadoresRegiones= response.data.colors;

                        }, function ( error ) {
                        toastr.error( error );
                        });
                      }
                      else
                      {
                        $scope.labelsGraficaFacilitadoresRegiones=[];
                        $scope.dataGraficaFacilitadoresRegiones=[];
                        $scope.backgroundColorGraficaFacilitadoresRegiones=[];
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }

                  cargaEstadisticasParticipantesCharlasDepartamento = function(fecha,fechaFin)
                  {
                    facilitadoresdService.getActividadesFacilitadores24('MENU'
                                                                        ,'MENUPARTICIPANTES'
                                                                        ,$scope.rangoEstadisticas.ID_REGION
                                                                        ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                        ,fecha
                                                                        ,fechaFin
                                                                        ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                      ).then( function ( response ) {
                      $scope.actividadesFacilitadoresJuecesParticipantes=response.data.data;

                      $scope.rangoEstadisticas.TITULO = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO;
                      $scope.rangoEstadisticas.TITULO_COLUMNA = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].TITULO_COLUMNA;
                      $scope.rangoEstadisticas.ID_ACTIVIDAD = $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ID_ACTIVIDAD;
                      $scope.actividadesFacilitadoresJuecesParticipantes[$scope.rangoEstadisticas.MENUASIGNADO].ACTIVO = "true";
                      $scope.rangoEstadisticas.MOSTRAR_FECHAS = true;

                      facilitadoresdService.getActividadesFacilitadores24('MAPAPARTICIPANTES'
                                              ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                              ,$scope.rangoEstadisticas.ID_REGION
                                              ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                              ,fecha
                                              ,fechaFin
                                              ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                            ).then( function ( response ) {

                        $scope.zingMapFacilitadores.shapes[0].options.style.items=response.data.mapa;
                        
                        $scope.labelsGraficaFacilitadores=response.data.labels;
                        $scope.dataGraficaFacilitadores=response.data.data;
                        $scope.backgroundColorGraficaFacilitadores= response.data.colors;
                        $scope.labelsIsoGraficaFacilitadores=response.data.isolabels;
                          
                        if ($scope.labelsIsoGraficaFacilitadores.length == 2)
                        {
                          $scope.rangoEstadisticas.COLOR = $scope.labelsIsoGraficaFacilitadores[0].color;
                        }

                        facilitadoresdService.getActividadesFacilitadores24('MUNICIPIOSPARTICIPANTES'
                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                          ,$scope.rangoEstadisticas.ID_REGION
                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                          ,fecha
                          ,fechaFin
                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                          ).then( function ( response ) {

                          $scope.facilitadoresMunicipios=response.data.data;
                          if ($scope.rangoEstadisticas.ID_BASE_COLOR == 3)
                          {
                            //municipios
                            for (i=0;i < $scope.labelsIsoGraficaFacilitadores.length;i++)
                            {
                              for (j=0;j < $scope.facilitadoresMunicipios.length;j++)
                              {
                                if ($scope.labelsIsoGraficaFacilitadores[i].id_iso_depto == $scope.facilitadoresMunicipios[j].ID_DEPARTAMENTO_ISO)
                                {
                                  $scope.facilitadoresMunicipios[j].COLOR = $scope.labelsIsoGraficaFacilitadores[i].color;
                                }
                              }
                            }
                          }

                        }, function ( error ) {
                        toastr.error( error );
                        });

                      }, function ( error ) {
                      toastr.error( error );
                      });

                      if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO))
                      {
                        facilitadoresdService.getActividadesFacilitadores24('REGIONESPARTICIPANTES'
                                                                          ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                                          ,fecha
                                                                          ,fechaFin
                                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                                                        ).then( function ( response ) {

                        $scope.labelsGraficaFacilitadoresRegiones=response.data.labels;
                        $scope.dataGraficaFacilitadoresRegiones=response.data.data;
                        $scope.backgroundColorGraficaFacilitadoresRegiones= response.data.colors;

                        }, function ( error ) {
                        toastr.error( error );
                        });
                      }
                      else
                      {
                        $scope.labelsGraficaFacilitadoresRegiones=[];
                        $scope.dataGraficaFacilitadoresRegiones=[];
                        $scope.backgroundColorGraficaFacilitadoresRegiones=[];
                      }

                      facilitadoresdService.getActividadesFacilitadores24('GRAFICAPARTICIPANTES'
                                              ,$scope.rangoEstadisticas.ID_ACTIVIDAD
                                              ,$scope.rangoEstadisticas.ID_REGION
                                              ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                              ,fecha
                                              ,fechaFin
                                              ,$scope.rangoEstadisticas.ID_BASE_COLOR
                                            ).then( function ( response ) {

                      $scope.labelsGraficaFacilitadoresSexos=response.data.labels;
                      $scope.dataGraficaFacilitadoresSexos=response.data.data;
                      $scope.backgroundColorGraficaFacilitadoresSexos= response.data.colors;

                      }, function ( error ) {
                      toastr.error( error );
                      });

                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }

                  $scope.cargaEstadisticasMunicipio=function(p_departamento_iso,mapa)
                  {
                  
                    var fecha = moment($scope.rangoEstadisticas.FECHA).format("DD-MM-YYYY");
                  
                    switch (mapa) 
                    {
                      case 1:
                        facilitadoresdService.getFacilitadoresSexoMunicipio($scope.facilitadoresSexo.ID_TIPO,p_departamento_iso).then( function ( response ) {
                          $scope.labelsMapa1=response.data.grafica.labels;
                          $scope.dataMapa1=response.data.grafica.data;
                          $scope.backgroundColorMapa1= response.data.grafica.colors;
                        }, function ( error ) {
                          toastr.error( error );
                        });
                          break;
                      case 2:
                        facilitadoresdService.getActividadesJuecesMunicipio(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.actividadesJueces.ID_TIPO,p_departamento_iso).then( function ( response ) {
                          $scope.labelsMapa2=response.data.grafica.labels;
                          $scope.dataMapa2=response.data.grafica.data;
                          $scope.backgroundColorMapa2= response.data.grafica.colors;
                        }, function ( error ) {
                          toastr.error( error );
                        });    
                          break;
                      case 3:
                        facilitadoresdService.getActividadesFacilitadoresMunicipio(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.rangoEstadisticas.ID_ACTIVIDAD,p_departamento_iso).then( function ( response ) {
                          $scope.labelsMapa3=response.data.grafica.labels;
                          $scope.dataMapa3=response.data.grafica.data;
                          $scope.backgroundColorMapa3= response.data.grafica.colors;
                        }, function ( error ) {
                          toastr.error( error );
                        });    
                          break;
                      case 4:
                        facilitadoresdService.getParticipantesCharlasMunicipio(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.participantesCharlas.ID_TIPO,p_departamento_iso).then( function ( response ) {
                          $scope.labelsMapa4=response.data.grafica.labels;
                          $scope.dataMapa4=response.data.grafica.data;
                          $scope.backgroundColorMapa4= response.data.grafica.colors;
                        }, function ( error ) {
                          toastr.error( error );
                        });    
                          break;
                    } 
                  }

                  $scope.chartOptions = angular.copy( $scope.chartOptionsLegendBarSimpleH);
               
                  $scope.rangoEstadisticas={};
                  $scope.facilitadoresSexo={};
                  $scope.actividadesJueces={};
                  $scope.actividadesFacilitadoresJuecesParticipantes=[];
                  $scope.participantesCharlas={};

                  $scope.facilitadoresSexo.TIPOS=[];
                  $scope.actividadesJueces.TIPOS=[];
                  $scope.participantesCharlas.TIPOS=[];

                  $scope.facilitadoresSexo.ID_TIPO="TOTAL";
                  $scope.actividadesJueces.ID_TIPO="TOTAL";
                  $scope.participantesCharlas.ID_TIPO="TOTAL";

                  $scope.rangoEstadisticas.ID_RANGO="4";
                  $scope.rangoEstadisticas.TIPO = "TOTAL";
                  $scope.rangoEstadisticas.ID_REGION = "0";                
                  $scope.rangoEstadisticas.ID_BASE_COLOR = $scope.ID_BASE_COLOR;

                  //para desplegar fecha inicial con un mes de anterioridad
                  /*initialDate = new Date()
                  temp = new Date(initialDate)
                  lastDayOfMonth = new Date(initialDate.getFullYear(), initialDate.getMonth(), 0);
                  day = '' + lastDayOfMonth.getDate();
                  ant= day * 86399.9 //dias en segundos
                  finalDate = new Date(temp.setSeconds(ant*-1))*/

                  finalDate = new Date();
                  finalDate.setFullYear( finalDate.getFullYear() - 1 ); //cambiar a -1, para que se cargue solo información del año anterior

                  $scope.rangoEstadisticas.FECHA = finalDate;
                  $scope.rangoEstadisticas.FECHA_FIN = new Date();
                  
                  $scope.rangoEstadisticas.ID_DEPARTAMENTO = "0";
                  $scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO = "0";
                  $scope.rangoEstadisticas.ID_DESPACHO = "0";
                  //asignacion de enfoque
                  $scope.rangoEstadisticas.MENUASIGNADO = 0;

                  $scope.menufacilitadores = false;
                  $scope.menuactividadesfacilitadores = false;
                  $scope.menuparticipantes = false;
                  $scope.menuactividadesjueces = false;
                  $scope.menucobertura = true;
                  $scope.pestanaActiva = 1;
                  
                  asignarTipoGrafico = function()
                  { 
                    if ($scope.pestanaActiva==1)
                    {
                      $scope.tipoGraficos=[{ID_TIPO_GRAFICO:1,TIPO_GRAFICO:'Mapa',ORDEN_GRAFICO:1,ENFOQUE:true,MOSTRAR:true},
                      {ID_TIPO_GRAFICO:2,TIPO_GRAFICO:'Regiones',ORDEN_GRAFICO:2,ENFOQUE:false,MOSTRAR:true},
                      {ID_TIPO_GRAFICO:3,TIPO_GRAFICO:'Departamentos',ORDEN_GRAFICO:3,ENFOQUE:false,MOSTRAR:true},
                      {ID_TIPO_GRAFICO:4,TIPO_GRAFICO:'Municipios',ORDEN_GRAFICO:4,ENFOQUE:false,MOSTRAR:true},
                      {ID_TIPO_GRAFICO:5,TIPO_GRAFICO:'Sexos',ORDEN_GRAFICO:5,ENFOQUE:false,MOSTRAR:false}];
                    }
                    else if ($scope.pestanaActiva==2)
                    {
                      $scope.tipoGraficos=[{ID_TIPO_GRAFICO:1,TIPO_GRAFICO:'Mapa',ORDEN_GRAFICO:1,ENFOQUE:true,MOSTRAR:true},
                                       {ID_TIPO_GRAFICO:2,TIPO_GRAFICO:'Regiones',ORDEN_GRAFICO:2,ENFOQUE:false,MOSTRAR:true},
                                       {ID_TIPO_GRAFICO:3,TIPO_GRAFICO:'Departamentos',ORDEN_GRAFICO:3,ENFOQUE:false,MOSTRAR:true},
                                       {ID_TIPO_GRAFICO:4,TIPO_GRAFICO:'Municipios',ORDEN_GRAFICO:4,ENFOQUE:false,MOSTRAR:true},
                                       {ID_TIPO_GRAFICO:5,TIPO_GRAFICO:'Sexos',ORDEN_GRAFICO:5,ENFOQUE:false,MOSTRAR:true}];
                    }
                    else if ($scope.pestanaActiva==5)
                      {
                        $scope.tipoGraficos=[{ID_TIPO_GRAFICO:1,TIPO_GRAFICO:'Mapa',ORDEN_GRAFICO:1,ENFOQUE:false,MOSTRAR:false},
                                         {ID_TIPO_GRAFICO:2,TIPO_GRAFICO:'Regiones',ORDEN_GRAFICO:2,ENFOQUE:true,MOSTRAR:true},
                                         {ID_TIPO_GRAFICO:3,TIPO_GRAFICO:'Departamentos',ORDEN_GRAFICO:3,ENFOQUE:false,MOSTRAR:true},
                                         {ID_TIPO_GRAFICO:4,TIPO_GRAFICO:'Municipios',ORDEN_GRAFICO:4,ENFOQUE:false,MOSTRAR:true},
                                         {ID_TIPO_GRAFICO:5,TIPO_GRAFICO:'Sexos',ORDEN_GRAFICO:5,ENFOQUE:false,MOSTRAR:true}];
                      }
                    else
                    {
                      $scope.tipoGraficos=[{ID_TIPO_GRAFICO:1,TIPO_GRAFICO:'Mapa',ORDEN_GRAFICO:1,ENFOQUE:false,MOSTRAR:false},
                                      {ID_TIPO_GRAFICO:2,TIPO_GRAFICO:'Regiones',ORDEN_GRAFICO:2,ENFOQUE:true,MOSTRAR:true},
                                      {ID_TIPO_GRAFICO:3,TIPO_GRAFICO:'Departamentos',ORDEN_GRAFICO:3,ENFOQUE:false,MOSTRAR:true},
                                      {ID_TIPO_GRAFICO:4,TIPO_GRAFICO:'Municipios',ORDEN_GRAFICO:4,ENFOQUE:false,MOSTRAR:true},
                                      {ID_TIPO_GRAFICO:5,TIPO_GRAFICO:'Sexos',ORDEN_GRAFICO:5,ENFOQUE:false,MOSTRAR:false}];
                    }
                  }
                  asignarTipoGrafico();
  
                  $scope.menumapa = true;
                  $scope.mostrar_mapa_grafica = true;

                  $scope.enfocarPestana = function(id,externo)
                  {
                    $scope.menucobertura = false;               
                    $scope.menufacilitadores = false;
                    $scope.menuactividadesfacilitadores = false;
                    $scope.menuactividadesjueces = false;
                    $scope.menuparticipantes = false;
                    $scope.pestanaActiva = id;
                    $scope.rangoEstadisticas.MENUASIGNADO = 0;
                    switch (id)
                    {
                      case 1:
                        //cobertura
                        $scope.menucobertura = true;               
                        if ($scope.menusexos)
                        {
                          $scope.enfocarPestanaInterna(1,true);
                        }
                      break;
                      case 2:
                        //facilitadores
                        $scope.menufacilitadores = true;
                      break;
                      case 3:
                        //actividades facilitadores
                        $scope.menuactividadesfacilitadores = true;
                        $scope.menumapa = false;
                        $scope.menuregiones = true;
                      break;
                      case 4:
                        //actividades jueces
                        $scope.menuactividadesjueces = true;
                      break;
                      case 5:
                        //participantes en charlas
                        $scope.menuparticipantes = true;
                      break;
                    }

                    if (externo)
                    {
                      $scope.ordenMenu = 0;
                      $scope.cargaEstadisticas(true,$scope.pestanaActiva,false);
                      asignarTipoGrafico();
                      if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                      {
                        $scope.enfocarPestanaInterna(2,true);
                      }
                      else
                      {
                        $scope.enfocarPestanaInterna(1,true);
                      }
                      $scope.selectedRegion($scope.dataDepartamentos[0],false);
                    }
                    else
                    {
                      $scope.cargaEstadisticas(true,$scope.pestanaActiva,false);
                    }
                  }

                  $scope.enfocarPestanaInternaMenu = function(actividad)
                  {
                    reinicioDataLabelChart();
                    for (c=0; c<$scope.actividadesFacilitadoresJuecesParticipantes.length; c++)
                    {
                      if ($scope.actividadesFacilitadoresJuecesParticipantes[c].ID_ACTIVIDAD == actividad)
                      {
                        $scope.rangoEstadisticas.MENUASIGNADO = c;
                        $scope.cargaEstadisticas(true,$scope.pestanaActiva,false);
                        break;
                      }
                    }
                  }

                  $scope.enfocarPestanaInterna = function(id,externo)
                  {
                    $scope.menumapa = false;         
                    $scope.menuregiones = false;
                    $scope.menudepartamentos = false;
                    $scope.menumunicipios = false;
                    $scope.menusexos = false;

                    if (externo)
                    {
                      $scope.grafica_regiones_activa = false;
                      $scope.grafica_departamentos_activa = false;
                    }

                    switch (id)
                    {
                      case 1:
                        //mapa
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar la región";
                        $scope.tooltip_volver_regiones = "Cargar todas las regiones";
                        $scope.tooltip_volver_departamentos_regiones = "Cargar departamentos de la región";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar departamentos de la región";
                        $scope.tooltip_volver_departamentos = "Cargar todos los departamentos";
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menumapa = true;     
                      break;
                      case 2:
                        //regiones
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menuregiones = true;
                      break;
                      case 3:
                        //departamentos
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar departamentos de la región";
                        $scope.tooltip_volver_regiones = "Cargar departamentos de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar departamentos de la región";
                        if ($scope.grafica_regiones_activa)
                        {
                          $scope.tooltip_volver_regiones = "Volver a todas las regiones";
                        }
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menudepartamentos = true;
                      break;
                      case 4:
                        //municipios
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar municipios de la región";
                        $scope.tooltip_volver_regiones = "Cargar municipios de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar municipios de la región";
                        $scope.tooltip_volver_departamentos = "Cargar municipios de todos los departamentos";
                        if ($scope.grafica_departamentos_activa)
                        {
                          $scope.tooltip_volver_regiones = "Volver a todas las regiones";
                          $scope.tooltip_filtrar_departamentos_regiones = "Volver a todos los departamentos de la región";
                        }
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menumunicipios = true;
                      break;
                      case 5:
                        //sexos
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menusexos = true;
                      break;
                    }
                  }

                  $scope.enfocarPestanaInternaFacilitadores = function(id)
                  {
                    $scope.menumapa = false;         
                    $scope.menuregiones = false;
                    $scope.menudepartamentos = false;
                    $scope.menumunicipios = false;
                    $scope.menusexos = false;
                    
                    $scope.rangoEstadisticas.TITULO_MAPA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_MAPA;
                    $scope.rangoEstadisticas.TITULO_GRAFICA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_GRAFICA;
                    $scope.rangoEstadisticas.TITULO_TABLA = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_TABLA;
                    $scope.rangoEstadisticas.MOSTRAR_FECHAS = $scope.facilitadoresMenu[$scope.ordenMenu].MOSTRAR_FECHAS;
                    $scope.rangoEstadisticas.TITULO_SEXOS = $scope.facilitadoresMenu[$scope.ordenMenu].TITULO_SEXOS;

                    switch (id)
                    {
                      case 1:
                        //mapa
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menumapa = true;     
                      break;
                      case 2:
                        //regiones
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menuregiones = true;
                      break;
                      case 3:
                        //departamentos
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menudepartamentos = true;
                      break;
                      case 4:
                        //municipios
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menumunicipios = true;
                      break;
                      case 5:
                        //sexos
                        $scope.rangoEstadisticas.ID_TIPO_GRAFICO = $scope.tipoGraficos[id-1].ID_TIPO_GRAFICO;
                        $scope.menusexos = true;
                      break;
                    }
                  }

                  $scope.cambiaTipoDato = function(orden)
                  {  
                    $scope.ordenMenu = orden-1; 
                    $scope.cargaEstadisticas(true,$scope.pestanaActiva,false);
                  }
                  $scope.ordenMenu = 0;

                  $scope.zingMapCobertura = 
                  {
                    gui: {
                      contextMenu: {
                        visible:false
                      }
                    },
                  globals: {
                    shadow:true
                  },
                  "background-color":"#FFF",
                  shapes: [
                    {
                      type: 'zingchart.maps',
                      options: {
                        name: 'gtm',
                        scrolling: true,
                        zooming: true,
                        style: {
                          label: {
                            visible:true
                          },
                          controls: {
                            visible: false
                          },
                          "background-color":"#F1F5F8",
                          "border-color":"#FFF",
                          "borderWidth": '1px',
                          hoverState: {
                            alpha: 0.3,
                            backgroundColor: '#FFF',
                            borderWidth: '3px'
                          }
                        }
                      }
                    }
                    ]
                  };

                  $scope.zingMapCoberturaRender = 
                  {
                    output : "canvas",
                    events : {
                      shape_click : function(p) 
                      {  
                        recarga_mapa = true;
                        for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                        {
                          if ($scope.dataDepartamentos[i].DEPARTAMENTO_ISO === p.shape.id) 
                          {
                            if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedRegion($scope.dataDepartamentos[i],false);
                            }
                            else if (($scope.rangoEstadisticas.ID_REGION == $scope.dataDepartamentos[i].ID_REGION) &&
                                      ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedDepartamento($scope.dataDepartamentos[i],false);
                            }
                            break;
                          }
                        }
                        if ((recarga_mapa) && (p.shape.id !== "BLZ"))
                        {
                          if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            $scope.selectedRegion($scope.dataDepartamentos[0],false);
                          }
                        }
                      }
                    }
                  };

                  $scope.zingMapFacilitadores = 
                  {
                    gui: {
                      contextMenu: {
                        visible:false
                      }
                    },
                  globals: {
                    shadow:true
                  },
                  "background-color":"#FFF",
                  shapes: [
                    {
                      type: 'zingchart.maps',
                      options: {
                        name: 'gtm',
                        scrolling: true,
                        zooming: true,
                        style: {
                          label: {
                            visible:true
                          },
                          controls: {
                            visible: false
                          },
                          "background-color":"#F1F5F8",
                          "border-color":"#FFF",
                          "borderWidth": '1px',
                          hoverState: {
                            alpha: 0.3,
                            backgroundColor: '#FFF',
                            borderWidth: '3px'
                          }
                        }
                      }
                    }
                    ]
                  };

                  $scope.zingMapFacilitadoresRender = 
                  {
                    output : "canvas",
                    events : {
                      shape_click : function(p) 
                      {  
                        recarga_mapa = true;
                        for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                        {
                          if ($scope.dataDepartamentos[i].DEPARTAMENTO_ISO === p.shape.id) 
                          {
                            if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedRegion($scope.dataDepartamentos[i],false);
                            }
                            else if (($scope.rangoEstadisticas.ID_REGION == $scope.dataDepartamentos[i].ID_REGION) &&
                                      ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedDepartamento($scope.dataDepartamentos[i],false);
                            }
                            break;
                          }
                        }
                        if ((recarga_mapa) && (p.shape.id !== "BLZ"))
                        {
                          if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            $scope.selectedRegion($scope.dataDepartamentos[0],false);
                          }
                        }
                      }
                    }
                  };
              
                  if (($scope.menuactividadesfacilitadores) || ($scope.menuactividadesjueces) || ($scope.menuparticipantes))
                  {
                    $scope.enfocarPestanaInterna(2,true);
                  }
                  else
                  {
                    $scope.enfocarPestanaInterna(1,true);
                  }
              }]
            }
          }
        })
    }
  ]
);
